Ext.define('SA.lq.view.GridColumnMenuFactory', {
    getAttributeColumnItems({sort, attribute}) {
        var staticItems = [
            {xtype: 'menu-add-remove-favorite-attribute', attribute},
            {xtype: 'menu-view-attribute-metadata', attribute},
            {xtype: 'menu-open-data-folder', attribute}
        ];

        if (sort) {
            return [...staticItems, this.getSortReverseItem(sort)];
        }

        return [
            ...staticItems,
            this.getSortAscItem({text: 'Sort, smallest to largest', attribute}),
            this.getSortDescItem({text: 'Sort, largest to smallest', attribute})
        ];
    },

    getItems({dataIndex: attribute, sort}) {
        var captionItem = {xtype: 'menu-attribute-caption', attribute};

        return attribute === 'name'
            ? [captionItem, ...this.getLocationColumnItems({sort})]
            : [captionItem, ...this.getAttributeColumnItems({sort, attribute})];
    },

    getLocationColumnItems({sort}) {
        if (sort) {
            return [this.getSortReverseItem(sort)];
        }

        return [
            this.getSortAscItem({text: 'Sort locations A-Z', attribute: 'name'}),
            this.getSortDescItem({text: 'Sort locations Z-A', attribute: 'name'})
        ];
    },

    getSortAscItem({text, attribute}) {
        return {text, handler: () => this.onSortItemClick(SA.model.DataSort.asc(attribute))};
    },

    getSortDescItem({text, attribute}) {
        return {text, handler: () => this.onSortItemClick(SA.model.DataSort.desc(attribute))};
    },

    getSortReverseItem(sort) {
        return {text: 'Reverse sort order', handler: () => this.onSortItemClick(sort.reversed())};
    },

    onSortItemClick(sort) {
        this.sortItemClickHandler(sort);
    },

    setSortItemClickHandler(sortItemClickHandler) {
        this.sortItemClickHandler = sortItemClickHandler;
    }
});